import React, { useState } from 'react';
import Collapsible from 'react-collapsible';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Link } from "react-router-dom";
import ReactStars from "react-rating-stars-component";
import { useForm } from "react-hook-form";

export const LensDetailRight = () => {
  const [popupactive, setPopupactive] = useState(false);
  const [toggleState, setToggleState] = useState(1);
  const [review, setReview] = useState(false)

  const toggleTab = (index) => {
    setToggleState(index);
  };

  const ratingChanged = (newRating) => {
    console.log(newRating);
  };

  const { register, handleSubmit, formState: { errors } } = useForm();
  const onSubmit = data => console.log(data);

  return (
    <>
      <div className="w-full lg:w-1/3 py-8">
        <h4 className="text-gray-400">Johnson & Johnson</h4>
        <h3 className="text-lg">Johnson & Johnson Acuvue Moist Dailies</h3>
        <h3 className="text-lg text-gray-400">10 Lenses/Box</h3>
        <h2 className="text-cyan-500 text-2xl mt-2">$399</h2>
        <p className="text-sm font-light">Frame + Lens</p>
        <div className="color_options mt-3">
          <Link to="#">
            <span className="color_option active rounded-full w-6 h-6 inline-block" style={{ background: "#ccc", }}></span>
          </Link>
        </div>
        <div className="grid grid-cols-2 gap-6">
          <div class="relative mb-3">
            <select class="border border-gray-300 p-3 my-3 rounded text-sm h-[46px] w-full">
              <option>0.00</option>
              <option>-0.25</option>
              <option>-0.50</option>
              <option>-1.00</option>
              <option>-1.25</option>
              <option>-1.50</option>
            </select>
            <label class="absolute top-0 left-0 h-full px-4 py-6 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Power(L)</label>
          </div>
          <div class="relative mb-3">
            <select class="border border-gray-300 p-3 my-3 rounded text-sm h-[46px] w-full">
              <option>0.00</option>
              <option>-0.25</option>
              <option>-0.50</option>
              <option>-1.00</option>
              <option>-1.25</option>
              <option>-1.50</option>
            </select>
            <label class="absolute top-0 left-0 h-full px-4 py-6 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Power(R)</label>
          </div>

        </div>
        <Link to="/cart" className="bg-cyan-500 text-white w-full mt-6 rounded p-2 tracking-wider text-center block">
          <span className="uppercase text-sm font-light">Add To Cart</span>
          <span className="block text-xs font-light">(with 1 Year Warranty &amp; 14 Day Return)</span>
        </Link>

        <div className="mt-12">
          <Collapsible trigger="Technical Information" >
            <div className="grid grid-cols-2 text-xs space-y-2">
              <span className="w-32 text-gray-500">Product Id</span><span>201093</span>
              <span className="w-32 text-gray-500">Model No.</span><span>VC E14934</span>
              <span className="w-32 text-gray-500">Frame Size</span>
              <span>Wide
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-4 h-4 inline ml-2 cursor-pointer">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z" />
                </svg>
              </span>
              <span className="w-32 text-gray-500">Frame Width</span><span>142 mm</span>
              <span className="w-32 text-gray-500">Frame Dimensions</span><span>55-18-145</span>
              <span className="w-32 text-gray-500">Frame colour</span><span>Silver Blue</span>
            </div>
            <Link to="#" className="text-cyan-500 text-sm mt-4 block mb-4">Show All Information</Link>
          </Collapsible>
          <Collapsible trigger="Review" open={true}>
            <div className="flex space-x-1">
              <i className="fa fa-star text-amber-500"></i>
              <i className="fa fa-star text-amber-500"></i>
              <i className="fa fa-star text-amber-500"></i>
              <i className="fa fa-star text-amber-500"></i>
              <i className="fa fa-star text-amber-500"></i>
            </div>
            <div>
              <h2 className="text-lg mt-6">Looking Good</h2>
              <p className="text-sm font-light my-2">Osm product</p>
              <p className="text-sm font-light">Abhishek R. - 3 Sep 2022</p>
            </div>
            <div className="grid grid-cols-2 gap-4 my-4 mb-6">
              <button className="rounded border border-cyan-500 uppercase py-3 text-cyan-500">More Reviews</button>
              <button onClick={() => setReview((prevState) => !prevState)} className="rounded bg-cyan-500 py-3 text-white uppercase">Write A Reviews</button>
            </div>
          </Collapsible>
          <hr className="border-b-1 border-gray-300" />
        </div>
      </div>

      {/* popup */}
      <div className={review === true ? "fixed z-[9999] bg-gray-900/50 w-full h-screen top-0 left-0 review" : "hidden"}>
        <div className="relative bg-white mt-10 p-7 rounded max-w-lg mx-auto ">
          <span onClick={() => setReview((prevState) => !prevState)} className="absolute right-4 top-4 cursor-pointer"><i class="fa fa-times"></i></span>
          <h2 className="text-center text-2xl font-light text-gray-600">Write A Review</h2>
          <h3 className="font-light mt-3 mb-2">How would you rate the product?</h3>
          <ReactStars
            count={5}
            onChange={ratingChanged}
            size={24}
            isHalf={true}
            emptyIcon={<i className="far fa-star"></i>}
            halfIcon={<i className="fa fa-star-half-alt"></i>}
            fullIcon={<i className="fa fa-star"></i>}
            activeColor="#ffd700"
          />
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-6 mt-3">
            <div class="relative">
              <input name="email" type="email" {...register("email", { required: true, maxLength: 30 })} class="w-full p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Email" autocomplete="off" />
              <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Email *</label>
              {errors.email?.type === 'required' && <p className="mb-2 mt-1 text-xs text-red-600">Email is required</p>}
            </div>
            <div className="grid grid-cols-2 gap-8">
              <div class="relative">
                <input name="name" type="text" {...register("name", { required: true, maxLength: 30 })} class="w-full p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Name" autocomplete="off" />
                <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Name *</label>
                {errors.name?.type === 'required' && <p className="mb-2 mt-1 text-xs text-red-600">Name is required</p>}
              </div>
              <div class="relative">
                <input name="title" type="name" {...register("title", { required: true, maxLength: 30 })} class="w-full p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700" placeholder="Title" autocomplete="off" />
                <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-3 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-3 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Title *</label>
                {errors.title?.type === 'required' && <p className="mb-2 mt-1 text-xs text-red-600">Title is required</p>}
              </div>
            </div>
            <div class="relative mb-5">
              <textarea name="review" {...register("review", { required: true, maxLength: 150 })} class="w-full p-1 pt-4 px-4 placeholder-transparent border border-gray-200 rounded-md peer focus:outline-none focus:border-gray-500 focus:shadow-sm text-gray-700 h-28" placeholder="review" autocomplete="off"></textarea>
              <label for="name" class="absolute top-0 left-0 h-full px-4 py-3 text-sm transition-all duration-100 ease-in-out origin-left transform scale-75 translate-x-1 -translate-y-4 opacity-75 pointer-events-none peer-placeholder-shown:opacity-100 peer-focus:opacity-75 peer-placeholder-shown:scale-100 peer-focus:scale-75 peer-placeholder-shown:translate-y-0 peer-focus:-translate-y-4 peer-placeholder-shown:translate-x-0 peer-focus:translate-x-1 text-gray-500">Review</label>
              {errors.review?.type === 'required' && <p className="mb-2 -mt-1 text-xs text-red-600">Review is required</p>}
            </div>
            <button class="rounded bg-cyan-500 py-3 px-6 text-white uppercase">Post Review</button>
          </form>
        </div>
      </div>
    </>
  )
}